import React, { useState, useRef, useEffect } from 'react';

/**
 * BarcodeScannerManager
 * Handles USB HID Barcode Scanners (which act as keyboards).
 * Keeps a hidden input field focused to capture the barcode string + Enter key.
 */
export default function BarcodeScannerManager({ onScan }) {
    const [barcode, setBarcode] = useState("");
    const inputRef = useRef(null);

    // Maintain focus on the hidden input field
    const handleBlur = () => {
        // Delay refocus slightly to allow user to click other inputs if needed
        setTimeout(() => {
            if (document.activeElement.tagName !== 'INPUT' &&
                document.activeElement.tagName !== 'TEXTAREA') {
                inputRef.current?.focus();
            }
        }, 100);
    };

    useEffect(() => {
        inputRef.current?.focus();

        // Window click listener to recapture focus if user clicks blank area
        const handleClick = () => {
            if (document.activeElement.tagName !== 'INPUT' &&
                document.activeElement.tagName !== 'TEXTAREA') {
                inputRef.current?.focus();
            }
        };

        window.addEventListener('click', handleClick);
        return () => window.removeEventListener('click', handleClick);
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (barcode.trim()) {
                onScan(barcode.trim());
                setBarcode(""); // Clear after scan
            }
        }
    };

    return (
        <div className="fixed bottom-4 left-4 z-[9999] opacity-0 pointer-events-none">
            <input
                ref={inputRef}
                type="text"
                value={barcode}
                onChange={(e) => setBarcode(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={handleBlur}
                placeholder="Barcode Scanner Active..."
                className="w-1 h-1"
            />
        </div>
    );
}
